module.exports = __webpack_public_path__ + "img/fitlab-heart.9bbf8931.svg";